module.exports = __webpack_public_path__ + "assets/a8f9fc74fd4fbca36908fad98274086e.woff";